
import { http } from './config'

class NFCeService {
  gerar(data) {
    return http.post(`/v1/nfce/gerar`, data);
  }

  cancelar(data){
    return http.post(`/v1/nfce/cancelar`, data)
  }

  imprimir(venda_id) {
    return http.post(`/v1/nfce/imprimir/${venda_id}`);
  }

  relatorio(data) {
    return http.get(`v1/nfce/relatorio?periodo_inicial=${data.periodo_inicial}&periodo_final=${data.periodo_final}`);
  }
}

export default new NFCeService();